<p-floatlabel>
    <p-autocomplete #roleAutocomplete
        [(ngModel)]="selectedRole" 
        [suggestions]="roles"
        [showClear]="true"
        [forceSelection]="true"
        styleClass="w-100"
        inputStyleClass="form-control"
        [minLength]="MinAutocompleteCharsToSearch"
        (completeMethod)="loadRoles($event)"
        (onSelect)="onChangeSelectedRole()"
        (onClear)="onClearRole()"
        optionLabel="name"
        [emptyMessage]="l('::NoData')"
        inputId="label">
        <ng-template let-item pTemplate="item">
            <div>{{ item.name }}</div>
        </ng-template>
    </p-autocomplete>
    <label for="roleAutocomplete">
        <app-label-content [isRequired]="isRequired">
            {{  l('::Role') }}
        </app-label-content>
    </label>
</p-floatlabel>